import { useState } from "react";
import { paymentTutorials } from "./../StaticData/PaymentTutorialData";
import TableChildTutorial from "../Component/Table/TableChildTutorial";
import logo from "../public/img/logo.png";

function PaymentTutorialPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <main className="landing-page payment-tutorial-page">
        <section className="payment-tutorial-hero">
          <div className="landing-container payment-tutorial-hero-grid">
            <div className="payment-tutorial-copy">
              <div className="landing-brand-chip">
                <img src={logo} alt="Goodnet Logo" />
                <span>Goodnet By Artamedia</span>
              </div>
              <h1>Cara bayar tagihan Goodnet.</h1>
              <p>Pilih metode pembayaran yang tersedia pada tagihan, lalu ikuti langkah sesuai channel pembayaran yang dipilih.</p>
            </div>
            <div className="payment-tutorial-summary">
              <div><strong>VA Bank</strong><span>BCA, BRI, dan VA bank lainnya</span></div>
              <div><strong>QRIS</strong><span>Pembayaran dari e-wallet dan mobile banking</span></div>
              <div><strong>Dashboard</strong><span>Nomor pembayaran tersedia di panel pelanggan</span></div>
            </div>
          </div>
        </section>

        <section className="landing-section landing-container payment-tutorial-section">
          <div className="landing-section-title">
            <span>Petunjuk Pembayaran</span>
            <h2>Cara Bayar Tagihan Goodnet.</h2>
            <p>Pilih metode pembayaran sesuai dengan keinginan anda.</p>
          </div>
          <div className="row g-3">
                {paymentTutorials.map((item, index) => (
                    <TableChildTutorial
                        key={item.id ?? index}
                        item = {item}
                        index = {index}
                        openIndex = {openIndex}
                        toggle = {toggle}
                    />
                ))}
          </div>
        </section>
      </main>
    </>
  );
};

export default PaymentTutorialPage;
